import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { ApiResponse } from '@core/models/interfaces';
import { Observable } from 'rxjs';
import { ApiService } from '../common';
import { SetForceLogoutVersionByOfficeRequest } from '@pages/authorized/caremoni/organization-management/organization-management.model';

@Injectable({
  providedIn: 'root',
})
export class CorpInfoService {
  constructor(private readonly http: ApiService) {}

  getAllCorp(): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getAllCorp}`;
    return this.http.get(url);
  }

  fetchOfficesByOrganizationId(orgIds: number[]): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.getOfficeByOrganizationIds}`;
    return this.http.post(url, orgIds);
  }

  updateToDynamoDB(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.updateDynamoDB}`;
    return this.http.post(url, body);
  }

  deleteSingleOffice(body: any): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.deleteSingleOffice}`;
    return this.http.delete(url, body);
  }

  setForceLogoutVersionByOffice(body: SetForceLogoutVersionByOfficeRequest): Observable<ApiResponse<any>> {
    const url = `${API_ENDPOINT.authConsole.setForceLogoutVersionByOffice}`;
    return this.http.post(url, body);
  }
}
